import { useQuery } from '@pinia/colada';

import propertyService from '../services/property.service';

export function getPropertyDetailsQueryKey(propertyId: string) {
  return ['property', propertyId, 'details'];
}

/**
 * One unit as its own page loads it, lease conditions included. The lists that carry a unit (inquiries, wants to
 * apply) leave its details out, so a panel opened from them asks here for, say, who takes the applications.
 */
export function usePropertyDetailsQuery(propertyId: () => string | undefined) {
  return useQuery({
    key: () => getPropertyDetailsQueryKey(propertyId() ?? ''),
    enabled: () => !!propertyId(),
    query: async () => (await propertyService.getById(propertyId()!)).data,
  });
}
